const items = [
  {
    title: 'Daily Driver Ticket Printing',
    desc: 'Generate and print driver tickets with all job details in a few clicks.',
    icon: '🎫',
  },
  {
    title: 'Hire Agreements & CPA Terms',
    desc: 'Send hire agreements direct from the Daybook via email, along with the CPA terms.',
    icon: '📝',
  },
  {
    title: 'Cloud-Based Access',
    desc: 'Manage your hire book anytime, anywhere—from PC, laptop, or tablet.',
    icon: '☁️',
  },
  {
    title: 'Airport Vicinity Warnings',
    desc: 'Automated alerts when operating near controlled airspace.',
    icon: '✈️',
  },
  {
    title: 'Hire Diary & Availability Overview',
    desc: 'View upcoming jobs, crane availability, and team assignments at a glance.',
    icon: '📅',
  },
  {
    title: 'Asset Register & Maintenance Log',
    desc: 'Track your entire fleet with logged services, repairs, and inspections.',
    icon: '🛠️',
  },
  {
    title: 'Service & LOLER Scheduling',
    desc: 'Maintain compliance with automated reminders and calendar tools.',
    icon: '🔧',
  },
  {
    title: 'Integrated Mapping Tools',
    desc: 'Produce site maps with Google Maps and What3Words for precise directions.',
    icon: '🗺️',
  },
  {
    title: 'Full Search Capability',
    desc: 'Find jobs with ease with our comprehensive search tools.',
    icon: '🔍',
  }
]

export default function HoverSections() {
  return (
    <section className="py-5 bg-gradient-to-b from-slate-250 to-slate-200 dark:from-slate-950 dark:to-slate-900">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-slate-700 dark:text-slate-100 text-3xl md:text-4xl font-bold">Everything your hire book should be</h2>
          <p className="text-slate-700 dark:text-slate-100 mt-3">Fast, auditable, and built for the realities of the crane industry.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {items.map((item) => (
            <div
              key={item.title}
              className="group glass rounded-3xl p-8 shadow-smooth transition transform hover:-translate-y-1 hover:shadow-xl hover:shadow-black/20"
            >
              <div className="text-4xl mb-4" aria-hidden>{item.icon}</div>
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p className="text-slate-700 dark:text-slate-300 mt-2">{item.desc}</p>
              <div className="mt-6 h-1 rounded-full bg-white/10 overflow-hidden">
                <div className="h-full w-0 group-hover:w-full transition-all duration-500 bg-sky-400"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
